import { Task, TaskType, Timestamp } from '@griply/types';
import { endOfDay, isAfter } from 'date-fns';

export type CanOpenHabitOptionsOptions = {
  today: Timestamp;
  displayDate?: Timestamp;
};

export const canOpenHabitOptions = (
  task: Task,
  { today, displayDate }: CanOpenHabitOptionsOptions,
): boolean => {
  if (task.type === TaskType.Task) {
    return false;
  }
  // computeHabitEntryUpdate spreads habit.schedules, so a schedule-less task would throw.
  if (!task.schedules?.length) {
    return false;
  }
  // Entries dated past today are ignored by the write, so the sheet's rows would no-op.
  return !isAfter(displayDate ?? today, endOfDay(today));
};
